const generalCvvValidatorRegex = /^\d{3,4}$/;
const amexCvvValidatorRegex = /^\d{4}$/;

export const isValid = (value: string, isAmexCard?: boolean) =>
  isAmexCard
    ? amexCvvValidatorRegex.test(value)
    : generalCvvValidatorRegex.test(value);
